import React from 'react';
import api from '../utils/api';
import { Navigate, redirect } from 'react-router-dom';
import UserDetails from './UserDetails';

const Users = ({ userData, updateUserData }) => {
    if (!userData.username) {
        console.log('No user data found, redirecting to login');
        return <Navigate to="/login" />;
    }
    const handleLogOut = () => {
        api.post('/api/v1/user/signout').then(() => {
            updateUserData({});
            console.log('Logged out');
        }).catch(err => {
            console.error('Error logging out:', err);
        });
    };

    return (
        <div>
            <h2>User</h2>
            <h3>Account data</h3>
            <UserDetails user={userData} />
            <button className="btn btn-primary" onClick={handleLogOut}>Log out</button>
        </div>
    );
};

export default Users;